import { FunctionComponent } from 'react';
import ReactPaginate from 'react-paginate';

import prevIcon from 'theme/icons/arrow-left.svg';
import nextIcon from 'theme/icons/arrow-right.svg';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutPagination: FunctionComponent<Props> = ({ currentPage, lastPage, onPageChange, hrefBuilder }) => ((
    <StyledComponent className="layout-pagination">
        <ReactPaginate
            pageCount={lastPage}
            forcePage={currentPage -1}
            pageRangeDisplayed={4}
            marginPagesDisplayed={1}
            breakLabel='...'
            onPageChange={({ selected }: { selected: number}) => {
                if(selected+1 === currentPage) {
                    return;
                }

                onPageChange(selected+1);
            }}
            hrefBuilder={(page: number) => hrefBuilder(page)}
            previousLabel={(
                <img
                    src={prevIcon}
                    className="prev-icon"
                    loading="lazy"
                />
            )}
            nextLabel={(
                <img
                    src={nextIcon}
                    className="next-icon"
                    loading="lazy"
                />
            )}
            renderOnZerPageCount={null}
        />
    </StyledComponent>
));

export default LayoutPagination;